// @flow
export const ERROR_CODE_DEPENDANT_RESOURCES_FOUND = 1105;
export const ERROR_CODE_REFERENCING_RESOURCES_FOUND = 1106;
